import React from 'react';
import { Error } from './Error';

const IpForbiddenErrorComponent = () => {
  return <Error title={{ key: 'pages:errorBoundary.ipForbiddenError' }} />;
};

export default IpForbiddenErrorComponent;
